import {ApiService} from "./api.service";
import {Injectable} from "@angular/core";

@Injectable()
export class ProductService {
    private perPage: number = 20;

    constructor(private apiService: ApiService)
    {}

    public get(id: string)
    {
        return this.search(id,1,1);
    }

    public search(query: string, page: number = 1, perPage: number = this.perPage)
    {
        const offset = (page-1)*perPage;
        return this.apiService.get('api/airtab/products',{search:query,offset:offset,numitems:perPage})
            .map((res) => {
                return ApiService.extractData(res);
            })
            .catch((err) => {
                return ApiService.handleError(err);
            });
    }

    public analyse(collection: string, excl_ingr: string = '', verpakking: Object = {}, prijs: Object = {}, categorie: Object = {}, hoeveelheid: Object = {}, merk: string = '', wensen: Object = {}, page: number = 1, numitems: number = this.perPage, ingreds: Object = {})
    {
        let params = {};
        if(collection == 'answer-ingredients') {
            params['answers'] = collection;
            params['excl_ingr'] = excl_ingr;
            params['verpakking'] = verpakking;
            params['prijs'] = prijs;
            params['categorie'] = categorie;
            params['hoeveelheid'] = hoeveelheid;
            params['merk'] = merk;
            params['wensen'] = wensen;
            params['page'] = page;
            params['numitems'] = numitems;
            params['offset'] = 1;

        } else {
            const offset = (page-1)*numitems;
            if(collection) params['answers'] = collection;
            if(excl_ingr) params['excl_ingr'] = excl_ingr;
            if(verpakking) params['verpakking'] = verpakking;
            if(prijs) params['prijs'] = prijs;
            if(categorie) params['categorie'] = categorie;
            if(hoeveelheid) params['hoeveelheid'] = hoeveelheid;
            if(merk) params['merk'] = merk;
            if(wensen) params['wensen'] = wensen;
            if(page) params['page'] = page;
            if(numitems) params['numitems'] = numitems;
            if(offset) params['offset'] = offset;
            if(ingreds) params['ingreds'] = ingreds;
            if(wensen) { 
                var wensen_new = params['wensen'].filter(function (el) {
                    return el != null && el != "";
                });
                params['wensen'] = wensen_new;
            }
            if(categorie) { 
                var categorie_new = params['categorie'].filter(function (el) {
                    return el != null && el != "";
                });
                params['categorie'] = categorie_new;
            }
            if(prijs) { 
                var prijs_new = params['prijs'].filter(function (el) {
                    return el != null && el != "";
                });
                params['prijs'] = prijs_new;
            }
            if(verpakking) { 
                var verpakking_new = params['verpakking'].filter(function (el) {
                    return el != null && el != "";
                });
                params['verpakking'] = verpakking_new;
            }
            if(hoeveelheid) { 
                var hoeveelheid_new = params['hoeveelheid'].filter(function (el) {
                    return el != null && el != "";
                });
                params['hoeveelheid'] = hoeveelheid_new;
            }
        }
        
       
        return this.apiService.post('api/airtab/analyse',params)
            .map((res) => {
                return ApiService.extractData(res);
            })
            .catch((err) => {
                return ApiService.handleError(err);
            });
    }

    public paynl()
    {
        return this.apiService.get('api/airtab/paynl')
            .map((res) => {
                return ApiService.extractData(res);
            })
            .catch((err) => {
                return ApiService.handleError(err);
            });
    }
}


// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/services/product.service.ts